exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ui.modal {\n  width: 90%!important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/send-demands-modal/send-demands-modal.component.css
// module id = ../../../../../src/app/_components/send-demands-modal/send-demands-modal.component.css
// module chunks = main